import { useEffect, useState } from "react"
import * as FI from "react-icons/fi"
import { useLocation } from "react-router-dom"
import { toast } from "react-toastify"
import * as CG from "../../../Components/Global"
import { useLandingContext } from "../../../Context"
import Styled from "./section_contact.module.css"

const SectionContact = () => {
  const [attendences, setAttendences] = useState<string>("community")
  const [name, setName] = useState<string>("")
  const [email, setEmail] = useState<string>("")
  const [whatsapp, setWhatsapp] = useState<string>("")
  const [subject, setSubject] = useState<string>("")
  const { handleGenerationUrlWhatsapp } = useLandingContext()
  const isMembers = attendences === "members"
  const location = useLocation()
  const searchParams = new URLSearchParams(location.search)
  const status = searchParams.get("status")

  const clearInputs = () => {
    setName("")
    setEmail("")
    setWhatsapp("")
    setSubject("")
  }

  function clearURL() {
    window.history.pushState({}, document.title, window.location.pathname)
  }

  async function handleContact(event: any) {
    event.preventDefault()
    const url = handleGenerationUrlWhatsapp({
      name,
      email,
      whatsapp,
      subject
    })
    const redirect = window.open("", "_blank")
    const hasData =
      name.trim() !== "" &&
      email.trim() !== "" &&
      whatsapp.trim() !== "" &&
      subject.trim() !== ""

    if (!hasData) {
      redirect.close()
      return toast.info("Preencha todos os campos!")
    }

    if (isMembers) {
      redirect.location.href = url
      setTimeout(() => {
        if (event.target instanceof HTMLFormElement) {
          event.target.submit()
        }
      }, 500)
      return
    }

    redirect.location.href = url
    clearInputs()
  }

  const loadVerifyStatus = () => {
    clearURL()

    if (status === "success")
      return toast.success("Aguarde! Em breve entraremos em contato.")

    toast.error("Ops! Houve erro ao entrar em contato.")
  }

  useEffect(() => {
    if (!status) return

    loadVerifyStatus()
  }, [])

  return (
    <section id='contato' className={Styled.container_contact}>
      <CG.H2>Contato</CG.H2>

      <form
        onSubmit={handleContact}
        action='https://api.staticforms.xyz/submit'
        method='POST'
      >
        <CG.FormGroup>
          <CG.InputText
            name='name'
            placeholder='Nome e Sobrenome*'
            value={name}
            onChange={e => setName(e.target.value)}
          />
        </CG.FormGroup>
        <CG.FormGroup>
          <CG.InputText
            name='email'
            placeholder='Digite seu e-mail*'
            value={email}
            onChange={e => setEmail(e.target.value)}
          />
        </CG.FormGroup>
        <input
          type='hidden'
          name='accessKey'
          value='fe7d9168-a2d1-4ac0-8217-e06dae255476'
        ></input>
        <input
          type='hidden'
          name='subject'
          value='Novo Contato - Site Jose Maria'
        />
        <input
          type='hidden'
          name='redirectTo'
          value='https://www.terapeutajosemaria.com.br?status=success'
        ></input>
        <CG.FormGroup>
          <CG.InputText
            name='phone'
            placeholder='Whatsapp*'
            value={whatsapp}
            onChange={e => setWhatsapp(e.target.value)}
          />
        </CG.FormGroup>
        <div className={Styled.container_options_contact}>
          <label
            className={Styled.label_group}
            onClick={() => setAttendences("community")}
          >
            <span
              className={
                attendences === "community"
                  ? Styled.checkbox
                  : Styled.icon_check_hidden
              }
            >
              <FI.FiCheck />
            </span>
            <p>Consulta Particular</p>
          </label>
          <label
            className={Styled.label_group}
            onClick={() => setAttendences("members")}
          >
            <span
              className={
                attendences === "members"
                  ? Styled.checkbox
                  : Styled.icon_check_hidden
              }
            >
              <FI.FiCheck />
            </span>
            <p>Atendimento Social</p>
            <small>
              Sujeito a disponibilidade de agenda e lista de espera.
            </small>
          </label>
        </div>
        <CG.FormGroup>
          <CG.TextArea
            name='message'
            placeholder='Assunto*'
            value={subject}
            onChange={e => setSubject(e.target.value)}
          />
        </CG.FormGroup>
        <CG.Button
          className={Styled.btn_form_action}
          color='var(--white-normal);'
          background='var(--blue-normal)'
          width={25}
          height={3}
          type='submit'
        >
          Entrar em contato
        </CG.Button>
      </form>
    </section>
  )
}

export default SectionContact
